export default __webpack_public_path__ + "static/thumb-landscape-f7ff24be31aa53ee4d5cdf05cd307fb9.jpg";